export { TooltipContainerComponent } from './tooltip-container.component';
export { TooltipDirective } from './tooltip.directive';
export { TooltipModule } from './tooltip.module';
export { TooltipConfig } from './tooltip.config';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
